import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';

const NATIVE_SCHEME = 'lftech.qpressen.test1';

export default function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    const hash = window.location.hash;

    // Android에서 접근한 경우: 커스텀 스킴으로 앱에 토큰 전달 (트램폴린)
    if (/Android/i.test(navigator.userAgent) && hash) {
      window.location.href = `${NATIVE_SCHEME}://auth/callback${hash}`;
      return;
    }

    // 웹: Supabase SDK가 hash에서 자동으로 세션 복원
    supabase.auth.getSession().then(({ data: { session } }) => {
      navigate(session ? '/dashboard' : '/login', { replace: true });
    });
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-violet-500" />
    </div>
  );
}
